export const throttle = (func, wait) => {
  let shouldBeCalled = true

  return (...args) => {
    if (!shouldBeCalled) return

    shouldBeCalled = false

    setTimeout(() => {
      shouldBeCalled = true
    }, wait)

    func.apply(this, args)
  }
}